import { Box, Grid2 as Grid, TextField, Typography } from '@mui/material';
import { PRODUCTION_FIELDS } from '../constants';
import { styles } from '../styles';
import type { DealDetailsFormField, DealDetailsFormValue, DealDetailsFormValues } from '../types';
import { FormSection } from './FormSection';

type ProductionSectionProps = {
  values: DealDetailsFormValues;
  onChange: (field: DealDetailsFormField, value: DealDetailsFormValue) => void;
  errors?: Record<string, boolean>;
};

export const ProductionSection = ({ values, onChange, errors = {} }: ProductionSectionProps) => {
  return (
    <FormSection title='Production'>
      <Grid size={12} spacing={2} container>
        {PRODUCTION_FIELDS.map(field => (
          <Grid size={{ sm: 12, md: 4 }} key={field.key}>
            <Box sx={{ mb: 1 }}>
              <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
                {field.label}
              </Typography>
            </Box>
            <TextField
              sx={styles.textField}
              name={field.key}
              value={values[field.key] || ''}
              onChange={event => onChange(field, event.target.value)}
              error={errors[field.key] || false}
              helperText={errors[field.key] ? 'Must be a number' : ''}
              fullWidth
              slotProps={{
                input: {
                  endAdornment: (
                    <Box sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>{field.unit}</Box>
                  ),
                },
              }}
            />
          </Grid>
        ))}
      </Grid>
    </FormSection>
  );
};
